import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

export default class extends BridgeComponent {
  static component = 'haptic';

  vibrate() {
    console.log('Haptic feedback triggered');
    const element = this.bridgeElement;
    const feedback = element.bridgeAttribute('feedback') || 'success';
    this.send('vibrate', { feedback });
  }
}
